<template>
  <div>
    <div class="modal is-active" v-show="showReceiveModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Receive Info</p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-6">
              <b-checkbox
                v-model="purchaseOrder.isReceived"
                type="is-info"
                size="is-small"
              >
                Received?
              </b-checkbox>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label is-small">QTY Received</label>
                <input
                  type="number"
                  class="input is-small"
                  v-model="purchaseOrder.qtyReceived"
                />
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label is-small">Date Received</label>
                <div class="control">
                  <input
                    type="date"
                    class="input is-small"
                    v-model="purchaseOrder.receivedDate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label is-small">Note</label>
                <textarea
                  style="height: 50px"
                  type="text"
                  class="input is-small"
                  v-model="purchaseOrder.note"
                  placeholder="Enter receive note (if any)"
                />
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button :class="buttonSave" @click="saveReceivePo">Save</button>
          &nbsp;
          <button class="button is-small" @click="closeModal(false)">
            Close
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import AuthService from "../../_services/auth";

const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();

export default {
  computed: {
    ...mapState("purchaseordertoreceive", {
      showReceiveModal: state => state.showReceiveModal,
      purchaseOrder: state => state.purchaseOrder
    })
  },
  data: () => ({
    buttonSave: appButton.isLoadingSuccess(false)
  }),
  methods: {
    ...mapActions("purchaseordertoreceive", [
      "openReceiveInfoModal",
      "getPaginatedPosToReceive"
    ]),
    closeModal(isLoadList) {
      this.openReceiveInfoModal({
        showReceiveModal: false
      });
      if (isLoadList) {
        this.getPaginatedPosToReceive({
          page: 1,
          pageSize: 10,
          query: ""
        });
      }
    },
    saveReceivePo() {
      const receiveInfo = {
        purchaseOrderDetailId: this.purchaseOrder.poDetailId,
        note: this.purchaseOrder.note,
        isReceived: this.purchaseOrder.isReceived,
        receivedDate: this.purchaseOrder.receivedDate,
        qtyReceived: this.purchaseOrder.qtyReceived
      };

      if (receiveInfo.qtyReceived > this.purchaseOrder.quantity) {
        appToast.danger("QTY Received is greater than the original QTY");
        return;
      }

      if (receiveInfo.receivedDate === "Invalid date") {
        appToast.danger("Please choose valid date.");
        return;
      }

      this.buttonSave = appButton.isLoadingSuccess(true);
      axios
        .put(
          `api/purchaseorders/receive-info/${
            receiveInfo.purchaseOrderDetailId
          }`,
          receiveInfo
        )
        .then(response => {
          appToast.success(response.data);
          this.closeModal(true);
        })
        .catch(error => {
          appToast.danger(error.response.data);
          console.log(error.response);
        })
        .then(() => {
          this.buttonSave = appButton.isLoadingSuccess(false);
          this.closeModal(true);
        });
    }
  }
};
</script>
